import React, { useState, useEffect } from 'react';
import Toast, { VARIANT } from '@nykaa/ui-components/Toast';
import { styled } from '@nykaa/ui-components';
import ErrorIcon from '@nykaa/ui-components/Icons/alert-warning';
import SuccessIcon from '@nykaa/ui-components/Icons/alert-positive-filled';
import { BACK_ONLINE, NO_INTERNET_CONNECTION } from './constant';

const ErrorIconWrap = styled(ErrorIcon)`
  height: 100%;
  path {
    fill: ${({ theme }) => theme.colors.negative};
  }
`;

const SuccessIconWrap = styled(SuccessIcon)`
  height: 100%;
  path {
    fill: ${({ theme }) => theme.colors.positive50};
  }
`;

export const Notification = () => {
  const [isOffline, setIsOffline] = useState(false);
  const [isBackOnline, setIsBackOnline] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('offline', () => {
        setIsOffline(true);
        setIsBackOnline(false);
      });
      window.addEventListener('online', () => {
        setIsBackOnline(true);
        setIsOffline(false);
      });
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('online', () => {
          setIsBackOnline(false);
        });

        window.removeEventListener('offline', () => {
          setIsOffline(false);
        });
      }
    };
  }, []);

  if (__SERVER__ || !window) return null;

  return (
    <>
      {isOffline && (
        <Toast
          icon={<ErrorIconWrap />}
          hideTimer
          timer={5}
          variant={VARIANT.single}
          message={NO_INTERNET_CONNECTION}
        />
      )}
      {isBackOnline && (
        <Toast
          variant={VARIANT.single}
          hideTimer
          timer={5}
          icon={<SuccessIconWrap />}
          message={BACK_ONLINE}
        />
      )}
    </>
  );
};
